import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { RefreshCw } from "lucide-react";
import type { AdminAuthorFileItem } from "@/types/article";
import { useSyncArticleContent } from "@/hooks/use-articles";

interface SyncDialogProps {
  file: AdminAuthorFileItem;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function SyncDialog({ file, open, onOpenChange }: SyncDialogProps) {
  const { mutate: sync, isPending } = useSyncArticleContent();

  const handleConfirm = () => {
    if (!file.articleId) return;
    sync(file.articleId, {
      onSuccess: () => onOpenChange(false),
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>콘텐츠 동기화</DialogTitle>
          <DialogDescription>
            원본 파일의 최신 콘텐츠로 아티클을 업데이트합니다.
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-lg border p-4 space-y-2">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">파일</span>
            <span className="text-sm truncate max-w-[200px]">
              {file.title}
            </span>
          </div>
        </div>

        <Alert>
          <RefreshCw className="h-4 w-4" />
          <AlertDescription>
            동기화하면 아티클의 콘텐츠가 원본 파일의 최신 버전으로 교체됩니다. 페이월 구간 설정은 유지됩니다.
          </AlertDescription>
        </Alert>

        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isPending}
          >
            취소
          </Button>
          <Button
            type="button"
            onClick={handleConfirm}
            disabled={isPending || !file.articleId}
          >
            {isPending ? "동기화 중..." : "동기화 확인"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
